
import { defineComponent, reactive, toRefs } from 'vue'
import { FormRules } from 'element-plus'
import { INPUT_NAMES } from '@/widgets/WReportCreation/constants/reportCreation'
import { useReportCreation } from '@/widgets/WReportCreation/composables/useReportCreation'

export default defineComponent({
  name: 'PatientCreationForm',

  setup() {
    const { patientCreationForm, patientCreationFormData } = useReportCreation()

    const formInputRefs = reactive({
      surnameRef: undefined,
      nameRef: undefined,
      patronymicRef: undefined,
      dateRef: undefined,
      emailRef: undefined,
      cartNumberRef: undefined,
      phoneRef: undefined,
    })

    const reportCreationValidationRules = reactive<FormRules>({
      surname: [
        { required: true, message: 'Введите фамилию', trigger: 'blur' },
      ],
      name: [{ required: true, message: 'Введите имя', trigger: 'blur' }],
      date: [
        { required: true, message: 'Введите дату рождения', trigger: 'blur' },
      ],
      email: [
        {
          type: 'email',
          message: 'Некорректный адрес эл.почты',
          trigger: 'blur',
        },
      ],
    })

    const handleChangeFocusedInput = (nextInput: string): void => {
      formInputRefs[nextInput].focus()
    }

    return {
      ...toRefs(formInputRefs),
      INPUT_NAMES,
      patientCreationForm,
      patientCreationFormData,
      reportCreationValidationRules,
      handleChangeFocusedInput,
    }
  },
})
